import { createElement } from "react";
import * as lucideIcons from "lucide-react";

import { getBrandIcon } from "./brand-icons";

// Resolve an icon by name: lucide first, then restored brand glyphs, then a
// safe fallback. A missing icon must never throw — a single bad icon_map value
// from the CMS used to crash the whole page render (blank page).
export const getIcon = (iconName) => {
  if (!iconName) {
    return lucideIcons.Link;
  }

  const lucideIcon = lucideIcons[iconName];
  if (lucideIcon) {
    return lucideIcon;
  }

  const brandIcon = getBrandIcon(iconName);
  if (brandIcon) {
    return brandIcon;
  }

  console.warn(`Icon "${iconName}" not found; using fallback.`);
  return lucideIcons.Link;
};

export const DynamicIcon = (props) => {
  const { name, ...rest } = props;
  return createElement(getIcon(name), rest);
};
